export const PROTOCOL_TYPES = [
  { value: "default", label: "Domyślny", tableLabel: "Zgłoszenie" },
  { value: "inspection", label: "Przegląd oddymiania", tableLabel: "Przegląd" },
  {
    value: "aeration_inspection",
    label: "Przegląd napowietrzenia",
    tableLabel: "Przegląd napowietrzenia",
  },
  {
    value: "flakt_protocol",
    label: "Wykonanie prac FLAKT",
    tableLabel: "Wykonanie prac FLAKT",
  },
  {
    value: "stairwell_inspection",
    label: "Oddymianie klatki",
    tableLabel: "Oddymianie klatki",
  },
];

export const getProtocolTypeLabel = (type) =>
  PROTOCOL_TYPES.find((t) => t.value === type)?.tableLabel ?? "";
